<nb-card>
  <nb-card-header *ngIf="mode === 'tutor'">
    {{ course.noRating }} đánh giá:
    <ngx-view-rating-star [rating]="course.rating"></ngx-view-rating-star>
  </nb-card-header>
  <nb-card-header *ngIf="mode === 'student'">
    <!--<nb-card-header *ngIf="mode === 'student' && (!myRatings || myRatings.length == 0)" >-->
    <form [formGroup]="ratingForm">
      <div class="form-group">
        <nb-actions size="tyni">
          <nb-action
            *ngFor="let item of ratingSelects"
            (click)="ratingSelected = item"
          >
            <nb-icon
              *ngIf="item <= ratingSelected"
              [status]="'warning'"
              class="action-icon"
              icon="star"
            ></nb-icon>
            <nb-icon
              *ngIf="item > ratingSelected"
              [status]="'warning'"
              class="action-icon"
              icon="star-outline"
            ></nb-icon>
          </nb-action>
        </nb-actions>
      </div>
      <div class="form-group">
        <input
          type="text"
          nbInput
          fullWidth
          formControlName="title"
          placeholder="Nhập tiêu đề"
          class="form-control"
          [(ngModel)]="rating.title"
        />
      </div>
      <div class="form-group">
        <textarea
          nbInput
          fullWidth
          id="inputDescription"
          placeholder="Nhập mô tả"
          class="form-control"
          formControlName="description"
          [(ngModel)]="rating.description"
        ></textarea>
      </div>
      <button
        type="submit"
        nbButton
        status="primary"
        size="small"
        [disabled]="submitted || !ratingForm.valid"
        [class.btn-pulse]="submitted"
        (click)="createRating()"
      >
        Gửi đánh giá
      </button>
    </form>
  </nb-card-header>

  <nb-card-body>
    <div *ngIf="myRatings && myRatings.length > 0" class="row">
      <div *ngFor="let item of myRatings; let i = index" class="col-md-12">
        <ngx-view-rating
          [rating]="item"
          [mode]="'myRating'"
          (onDeleteRating)="deleteRating($event)"
        ></ngx-view-rating>
      </div>
    </div>

    <div class="row">
      <div *ngFor="let item of ratings; let i = index" class="col-md-12">
        <ngx-view-rating
          [rating]="item"
          (onDelete)="onDelete($event)"
        ></ngx-view-rating>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer *ngIf="!done">
    <nb-actions fullWidth size="small" class="see-more-button">
      <nb-action (click)="getMore()">
        <nb-icon icon="more-horizontal-outline"></nb-icon>
        <span class="text-link">Xem thêm</span>
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
